// Force every date/time the portal formats to London time, whatever the device clock zone is.
const TZ = "Europe/London";
const withTz = (o) => ({ ...(o || {}), timeZone: (o && o.timeZone) || TZ });

const NativeDTF = Intl.DateTimeFormat;
function LondonDTF(locales, options) {
  return new NativeDTF(locales, withTz(options));
}
LondonDTF.prototype = NativeDTF.prototype;
LondonDTF.supportedLocalesOf = NativeDTF.supportedLocalesOf;
Intl.DateTimeFormat = LondonDTF;

["toLocaleString", "toLocaleDateString", "toLocaleTimeString"].forEach((fn) => {
  const native = Date.prototype[fn];
  // eslint-disable-next-line no-extend-native
  Date.prototype[fn] = function (locales, options) {
    return native.call(this, locales, withTz(options));
  };
});
